import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum ProofOfIdentityFormErrorStatesEnum {
    UploadFileFailed = ErrorStateScheduleEnum.ProofOfIdentityFormStatesStartIndex,
    CreateDocumentFailed,
    UpdateDocumentFailed
}
